import styled from 'styled-components'

export const ModalContent = styled.div`
  max-width: 500px;
  width: 100%;
`

export const SubTitleContent = styled.div`
  p{
    color: #898989
  }
`

export const AppointmentTime = styled.div`
  border: 1px solid #C1C1C1;
  padding: 8px 15px;
  border-radius: 20px;
  text-align: center;
  margin: 0 auto 24px;
  display: block;
  width: fit-content;

  p {
    color: #898989;
  }
`

export const Explanation = styled.div`
  text-align: center;
  margin-bottom: 24px;
  line-height: 1.5;
`

export const AdviceBox = styled.div`
  background-color: #FFFEB5;
  padding: 20px 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  line-height: 1.5;
`

export const WhatsAppSection = styled.div`
  margin-bottom: 24px;
`

export const WhatsAppButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 24px;
  gap: 8px;
`

export const ActionButton = styled.div`
  text-align: center;

  .CancelErrorModal__GotItButton {
    background-color: #1F35B5;
    color: white;
    min-width: 200px;
  }
`
